import { makeStyles } from '@material-ui/core'
import React, { useEffect, useState } from 'react'

const useStyles = makeStyles((theme) => ({
    widgetCell: {
        width: "calc(100% - 10px)",
        margin: 5,
        float: "left",
        [theme.breakpoints.up(600)]: {
          width: "calc(50% - 10px)",
          display: "block",
        },
        [theme.breakpoints.up(900)]: {
          width: "calc(33.3333333% - 10px)",
        },
        [theme.breakpoints.up(1200)]: {
          width: "calc(25% - 10px)",
        },
      },
}))

function LoadingHud({mode} : {mode: string}) {
  const [loadingtext, setLoadingtext] = useState("Loading...")
  const theme = localStorage.getItem('theme')
  const [support, setSupport] = useState(false)
  useEffect(() => {
    const generateText = setInterval(() => {
      setLoadingtext(prevText => {
        if (prevText === "Loading...") return "Just a moment...";
        if (prevText === "Just a moment...") return "Hang tight...";
        if (prevText === "Hang tight...") return "Loading...";
        return prevText;
      });
    }, 4000);
    setTimeout(() => setSupport(true), 12000)
  
    return () => clearInterval(generateText);
  }, []);

  return (
    <div className="loading-placeholder-container" style={{overflow: 'hidden', position: 'relative', width: '100vw', height: '100vh', background: theme === 'light' ? "white" : "#333"}}>
        <div style={{position: 'absolute', left: '50%', top: '50%', transform : 'translate(-50%, -50%)', width: 400, height: 300, margin: 0, textAlign: 'center' }}>
        <h2 style={{color: theme === 'light' ? "black" : "white"}}>{loadingtext}</h2>
        <span className={`loading-spin ${theme === 'light' ? "light" : "dark"}`} />
        {support && <h4 style={{color: theme === 'light' ? "black" : "white"}}>Things are taking longer than expected. Give us a moment while we try again. </h4>}
        </div>
    </div>
  )
}

export default LoadingHud